<div class="drill-planning__body">
  <app-drill-grid
    [blasts]="blasts()"
    [shiftConfig]="shiftConfig()"
    [startDate]="bounds().start"
    [endDate]="bounds().end"
    [timeScale]="timeScale()"
    [colorBy]="colorBy()"
    (blastClick)="openBlast($event)"
    (sessionClick)="openSession($event)" />

  @if (loading()) {
    <div class="drill-planning__overlay" role="status" aria-live="polite">
      <span class="drill-planning__spinner" aria-hidden="true"></span>
      <span>{{ 'PLANNING.LOADING' | translate }}</span>
    </div>
  } @else if (blasts().length === 0) {
    <div class="drill-planning__empty">{{ 'PLANNING.NO_ACTIVITY' | translate }}</div>
  }
</div>
